import React from 'react';
import usePageTranslation from '../../../../shared/hooks/usePageTranslation';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ page, totalPages, onPageChange }) => {
  const { t } = usePageTranslation('panel', 'UserRolesManagement');

  if (totalPages <= 1) return null;

  return (
    <div className="mt-4 flex items-center justify-between">
      <button
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="rounded-lg border border-[#223046] bg-[#0b1220] px-4 py-2 text-sm text-cockpit-text disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#0b1220] transition-colors"
      >
        {t('pagination.previous')}
      </button>
      <span className="text-sm text-cockpit-text-2">
        {t('pagination.page')} {page} / {totalPages}
      </span>
      <button
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="rounded-lg border border-[#223046] bg-[#0b1220] px-4 py-2 text-sm text-cockpit-text disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#0b1220] transition-colors"
      >
        {t('pagination.next')}
      </button>
    </div>
  );
};

export default Pagination;
